<template>
  <el-row class="auxcard el-row">
    <form ref="aux_form" class="aux_form" target="auxiframe"  method="post" action="https://dashboard.auxmode.com/AuxMode_Dashboard/Auth">

      <input type="text" name="username" id="username_aux"  :value="username" style="display: none;"/>
      <input type="password" name="password" id="password_aux"  :value="password" style="display: none;"/>

      <button id="aux_submit" ref="aux_submit" type="submit" @click.prevent="submit" class="btn-main" style="display:none;">Refresh</button>
    </form>
    <iframe class="auxmode-iframe" name="auxiframe" src="https://dashboard.auxmode.com/AuxMode_Dashboard/dashboard-cms.jsp" frameborder="0" scrolling="yes"></iframe>
  </el-row>
</template>

<script>

import {mapState} from "vuex";

export default {
  data() {
    return {
    }
  },

  computed: {
    ...mapState('auth', ['user']),
    username(){
      return this.user.auxu
    },
    password(){
      return this.user.auxp
    }
  },

  methods: {
    submit(){
      this.$refs.aux_form.submit()
    }
  },

  mounted() {
    if(this.username && this.password){
      this.$refs.aux_submit.click()
    }
  },
}
</script>

<style lang="scss" scoped>
.auxmode-iframe {
  position: absolute;
  top: 0;
  left: 0px;
  width: 1850px;
  height: 900px;
  border: none;
  margin-left: -280px;
  margin-top: -124px;
}
.auxcard {
  width: 100%;
  max-width: 1850px;
}
.bell_img{
  margin-right: 10px;
}
.auxmode_img{
  z-index:950;
  position: absolute;
  right: 0;
  margin-right: 55px;
}
.aux_form{
  width: 100%;
  margin-top: 300px;
  margin-left: 700px;
  z-index: 999;
  position: absolute;
}
</style>